import { Typography } from '@mui/material'

import { Box } from '@mui/system'

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: '100vh',
    height: '100%',
  },
}

const SupervisorSuccessForm = ({ icon, mode }: { icon: JSX.Element; mode: string }) => {
  return (
    <Box sx={styles.wrapper}>
      <Box sx={{ maxWidth: '400px', width: '100%' }}>
        {icon}
        <Typography color='primary' sx={{ fontSize: '1.75rem', mb: 2 }}>
          {mode.charAt(0).toUpperCase() + mode.slice(1)}
        </Typography>
        <Typography sx={{ fontSize: '1rem' }}>
          You successfully {mode} this application. Kindly check the email sent to you for more
          details.
        </Typography>
      </Box>
    </Box>
  )
}

export default SupervisorSuccessForm
